import React from 'react';
import { Icon, Tooltip } from '@fourthwall/components';
import { ExclamationMarkIcon } from '@fourthwall/icons';
import * as S from './ErrorBadge.styled';
export const ErrorBadge = () => (React.createElement(Tooltip, { reference: React.createElement(S.Container, null,
        React.createElement("div", null, "Error"),
        React.createElement("div", null,
            React.createElement(Icon, { component: ExclamationMarkIcon, height: 16 }))) }, "Please contact our support or your partner manager."));
